import React from 'react';
import {
  View, StyleSheet, Text, Pressable,
} from 'react-native';
import Colors from '../../../../constants/Colors';
import { openInNewTab } from '../../../../constants/Utils';

interface AssetCardFieldProps {
  title: string,
  value: string,
}

const AssetCardLink = ({ title, value }: AssetCardFieldProps) => <View style={styles.container}>
  <Text style={styles.title}>{title}</Text>
  {value?.length > 0
    ? <Pressable onPress={() => openInNewTab(value)}>
      <Text style={styles.link} numberOfLines={1} ellipsizeMode='tail'>
        {value}
      </Text>
    </Pressable>
    : <Text style={styles.value} numberOfLines={1} ellipsizeMode='tail'>
      {'-'}
    </Text>}
</View>;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  title: {
    fontSize: 12,
    lineHeight: 14,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    marginBottom: 4,
  },
  link: {
    fontSize: 12,
    lineHeight: 14,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlue500,
    textDecorationLine: 'underline',
    marginBottom: 12,
  },
  value: {
    fontSize: 12,
    lineHeight: 14,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack600,
    marginBottom: 12,
  },
});

export default AssetCardLink;
